// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1MNXh","label":"Category_label__2GpEH","content":"Category_content__1U71Y","header":"Category_header__1fndz","location":"Category_location__kiwOw"};